module.exports = __webpack_public_path__ + "static/media/ok.c7262d9f.svg";